export const useLinkConfig = () => {
    // --------------------------------------------
    // CATEGORIES (for "Home Appliances" section)
    // --------------------------------------------
    const navCategoryLinks = [
        { href: `/appliances/Laundry`, text: 'Laundry' },
        { href: `/appliances/Refrigeration`, text: 'Refrigeration' },
        { href: `/appliances/Cooking`, text: 'Cooking' },
        { href: `/appliances/Dishwasher`, text: 'Dishwasher' },
        { href: `/appliances/LG Studio`, text: 'LG Studio' },
        // { href: `/appliances/`, text: 'All Categories' }
        // { href: `/categories/Laundry`, text: 'Laundry' },
        // { href: `/categories/Refrigeration`, text: 'Refrigeration' },
        // { href: `/categories/Cooking`, text: 'Cooking' },
        // { href: `/categories/Dishwasher`, text: 'Dishwasher' },
        // { href: `/categories/LG Studio`, text: 'LG Studio' },
        // { href: `/categories/`, text: 'All Categories' }
    ];
    

    const allCategoryLink = { href: `/appliances/`, text: 'All Categories' };



    // --------------------------------------------
    // RESOURCES (for "Resources" section)
    // --------------------------------------------
    const resourceLinks = [
        { href: `/resources/definitions`, text: 'Feature Definitions' },
        { href: `/resources/warranties`, text: 'Limited Warranties' },
    ];


    // --------------------------------------------
    // EXCLUSIVE OFFERS
    // --------------------------------------------
    const exclusiveLinks = [
        { href: `/product-list`, text: 'Product List Builder' }
    ];

    // --------------------------------------------
    // SUPPORT & EXTERNAL
    // --------------------------------------------
    const nativeEmailLinks = [
        { href: 'mailto:productguide@teamlg.ca', text: 'productguide@teamlg.ca' }
    ];

    const legalLinks = [
        { href: `/terms`, text: 'Terms' },
        { href: `/privacy`, text: 'Privacy' }
    ];

    return {
        navCategoryLinks,
        allCategoryLink,

        resourceLinks,

        exclusiveLinks,
        nativeEmailLinks,
        legalLinks
    };
};
